import App from './App'
import Drivers from './Drivers'
import Vehicles from './Vehicles'
import Carriers from './Carriers'
import TypeVehicle from './TypeVehicle'
import Dashboards from './Dashboards'
import WSocket from './WebSocket'
import Priority from './Priority'
import Permissions from './Permissions'
import OCR from './OCR'
import Checks from './Checks'
import RiskManager from './RiskManager'
import UserTracking from './UserTracking'
import Tracking from './Tracking'
import User from './User'
import { Checklist as YardChecklist } from './Yard'
import DashboardCards from './DashboardCards'
import sso from './Sso'

export default {
  App,
  Drivers,
  Vehicles,
  Carriers,
  TypeVehicle,
  Dashboards,
  WSocket,
  Priority,
  Permissions,
  OCR,
  Checks,
  RiskManager,
  UserTracking,
  Tracking,
  User,
  YardChecklist,
  DashboardCards, 
  sso
}
